import { Component, OnInit, AfterViewInit, Inject, Output, EventEmitter } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { DbService } from '../core/services/db.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  configData;
  openSwitch = false;

  menu: any = [
    {
      label: '대시보드',
      icon: 'bx-home',
      link: '/dashboard',
    },
    {
      label: '회원 관리',
      icon: 'bx-user',
      link: '/user-list',
    },
    {
      label: '상품 관리',
      icon: 'bx-list-ul',
      subItems: [
        {
          label: '카테고리 관리',
          link: '/category-list',
        },
        {
          label: '상품 관리',
          link: '/product-manager',
        },
        {
          label: '주문 관리',
          link: '/order-manager',
        },
        {
          label: '취소/교환/반품 관리',
          link: '/refund-manager',
        },
        {
          label: '인기/큐레이션 관리',
          link: '/best-manager',
        },
        {
          label: '상품리뷰 관리',
          link: '/review-manager',
        },
        {
          label: '상품문의 관리',
          link: '/product-inquiry-manager',
        },
        {
          label: '프로모션 관리',
          link: '/exhibition-manager',
        },
        {
          label: '배너 관리',
          link: '/banner-edit',
        },
      ],
    },
    {
      label: '커뮤니티 관리',
      icon: 'bx-news',
      subItems: [
        {
          label: '카테고리 관리',
          icon: '',
          link: '/category-management',
        },
        {
          label: '게시글 관리',
          icon: '',
          link: '/post-management',
        },
        {
          label: '댓글 관리',
          link: '/comment-management',
        },
        {
          label: '신고 관리',
          link: '/report-user',
        },
      ],
    },
    {
      label: '채팅 관리',
      icon: 'bx-chat',
      subItems: [
        {
          label: '채팅 관리',
          link: '/chat-management',
        },
      ],
    },
    {
      label: '서비스/정보관리',
      icon: 'bx-note',
      subItems: [
        {
          label: '1:1 문의 관리',
          link: '/inquiry',
        },
        {
          label: '공지사항',
          link: '/notice',
        },

        {
          label: '자주 묻는 질문',
          link: '/faq',
        },
        {
          label: '개인정보/서비스 이용약관',
          link: '/terms',
        },
      ],
    },
    {
      label: '푸터 관리',
      icon: 'bx-user',
      subItems: [
        {
          label: '푸터 관리',
          link: '/footer-list',
        },
      ],
    },
    {
      label: '배송 관리',
      icon: 'bx-list-ul',
      subItems: [
        {
          label: '계좌 관리',
          link: '/account-info',
        },
        {
          label: '배송비 관리',
          link: '/delivery-info',
        },
      ],
    },
  ];

  routerUrl: string;

  constructor(
    // private eventService: EventService,
    private router: Router,
    @Inject(DOCUMENT) private document: any,
    private db: DbService
  ) {
    // this.checkInfo();

    router.events.forEach(event => {
      if (event instanceof NavigationEnd) {
        // this._activateMenuDropdown();
        this.routerUrl = event.url;
      }
    });
  }

  ngOnInit() {
    //사이드바 정의
    document.body.setAttribute('data-sidebar', 'dark');
    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };
  }

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  isCondensed = false;

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
    this.onSettingsButtonClicked();
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');

    if (window.screen.width <= 768) {
      document.body.classList.remove('vertical-collpsed');
    }
  }

  ngAfterViewInit() {
    // this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  scrollable() {
    document.body.setAttribute('data-layout-scrollable', 'true');
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    // this.mobileMenuButtonClicked.emit();
    this.onToggleMobileMenu();
  }

  /**
   * Logout the user
   */
  logout() {
    this.db.logoutUser().then(() => {
      this.router.navigate(['/account/login']);
    });
  }

  public hide() {
    document.body.classList.remove('right-bar-enabled');
  }

  open(list, menu, mi) {
    const activeTag = document.querySelector<HTMLElement>('.active');
    if (activeTag) {
      activeTag.classList.remove('active');
    }
    if (list.openSwitch) {
      list.openSwitch = false;
    } else {
      list.openSwitch = true;
      menu.forEach(ele => {
        if (ele != list && ele.openSwitch == true) {
          ele.openSwitch = false;
        }
      });

      if (list.subItems && list.subItems.length > 0) {
        for (let index = 0; index < list.subItems.length; index++) {
          const element = list.subItems[index];

          if (element.link == this.routerUrl) {
            const aTag = document.querySelector<HTMLElement>(`.atag${mi}${index}`);
            aTag.classList.add('active');
          }
        }
      }
    }
  }

  close(aTag: HTMLElement) {
    aTag.classList.add('active');
    this.menu.forEach((ele: any) => {
      ele.openSwitch = false;
    });
  }
}
